import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import Helmet from 'react-helmet';
import { LeftNavLayout } from 'containers';
import { EmptyState, PageHeader, GroupPostItem, Spinner } from 'components';
import { getGroupPosts, parseLink } from 'redux/modules/groupPosts';
import { getAllClients } from 'redux/modules/teamManagement';
import { GroupPostForm, GroupPostPreview } from '../../components/GroupPost';
import Pagination from 'react-js-pagination';
import RaisedButton from 'material-ui/RaisedButton';
import * as styles from './GroupPost.scss';
var GroupPosts = (_dec = connect(function (state) {
  return {
    allClients: state.teamManagement.allClients,
    isLoadingClients: state.teamManagement.isLoadingClients,
    upcomingPosts: state.groupPosts.upcomingPosts,
    pastPosts: state.groupPosts.pastPosts,
    upcomingCount: state.groupPosts.upcomingCount,
    pastCount: state.groupPosts.pastCount,
    upcomingPage: state.groupPosts.upcomingPage,
    pastPage: state.groupPosts.pastPage,
    parsedLinks: state.groupPosts.parsedLinks,
    selectedFields: state.teamManagement.selectedClientTableColumns,
    theme: state.theme
  };
}, {
  getAllClients: getAllClients,
  getGroupPosts: getGroupPosts,
  parseLink: parseLink
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GroupPosts, _Component);

  var _super = _createSuper(GroupPosts);

  function GroupPosts(props) {
    var _this;

    _classCallCheck(this, GroupPosts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function (pageNumber) {
      var isPast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.props.getGroupPosts(isPast, parseInt(pageNumber, 10)).then(function (res) {
        res.data.data.forEach(function (post, index) {
          if (post.linkUrl && _this.props.parsedLinks && !_this.props.parsedLinks[post.id]) {
            _this.props.parseLink(post.linkUrl, post.id);
          }
        });
      });
    });

    _this.state = {};
    return _this;
  }

  _createClass(GroupPosts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.allClients && !this.props.allClients.length) {
        this.props.getAllClients({
          orgTypeId: "".concat(this.props.theme.org) === '0' ? 3 : null,
          parentOrganizationId: this.props.theme.org
        });
      }

      this.props.getGroupPosts(true).then(function (res) {
        res.data.data.forEach(function (post, index) {
          if (post.linkUrl && _this2.props.parsedLinks && !_this2.props.parsedLinks[post.id]) {
            _this2.props.parseLink(post.linkUrl, post.id);
          }
        });
      });
      this.props.getGroupPosts().then(function (res) {
        res.data.data.forEach(function (post, index) {
          if (post.linkUrl && _this2.props.parsedLinks && !_this2.props.parsedLinks[post.id]) {
            _this2.props.parseLink(post.linkUrl, post.id);
          }
        });
      });
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this3 = this;

      var clientsWithSocialAccounts = this.props.allClients && !!this.props.allClients.length ? this.props.allClients.filter(function (client) {
        return client.SocialAccounts && !!client.SocialAccounts.length;
      }) : [];
      console.log('@#@#*@&*#*');
      console.log(clientsWithSocialAccounts);
      var postLimit = 10;
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 0,
          display: 'flex'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Group Post"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: 36,
          paddingTop: 16,
          paddingBottom: 24
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Group Posts"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RaisedButton, {
        onClick: function onClick() {
          browserHistory.push('/global/group-posts/compose');
        },
        secondary: true,
        label: "New Group Post",
        style: {
          marginTop: 12
        }
      }))), !this.props.isLoadingClients && !!clientsWithSocialAccounts.length && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36
        }
      }, (!!this.props.upcomingPosts.length || !!this.props.pastPosts.length) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.postsWrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.postsWrapTitle
      }, "Upcoming Group Posts"), this.props.upcomingPosts.length ? this.props.upcomingPosts.map(function (post, index) {
        var imageUrl = post.S3Files.length ? post.S3Files[0].fullyQualifiedUrl : '';
        return /*#__PURE__*/React.createElement(GroupPostItem, {
          post: post,
          image: post.linkUrl && _this3.props.parsedLinks && _this3.props.parsedLinks[post.id] ? _this3.props.parsedLinks[post.id].imageUrl : imageUrl,
          message: post.message ? post.message : _this3.props.parsedLinks && _this3.props.parsedLinks[post.id] ? _this3.props.parsedLinks[post.id].title : '',
          publishAt: post.publishAt,
          key: "postListItem_".concat(index)
        });
      }) : /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Create A Group Post",
        buttonOnClick: function buttonOnClick() {
          browserHistory.push('/global/group-posts/compose');
        },
        text: "There are no upcoming group posts.",
        iconName: "fa fa-send",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }), !!this.props.upcomingCount && this.props.upcomingCount > postLimit && /*#__PURE__*/React.createElement("div", {
        style: {
          borderTop: '1px solid #8b8b8b',
          paddingTop: 16,
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement(Pagination, {
        activePage: parseInt(this.props.upcomingPage, 10),
        itemsCountPerPage: postLimit,
        totalItemsCount: this.props.upcomingCount,
        pageRangeDisplayed: 5,
        onChange: function onChange(pageNumber) {
          _this3.handlePageChange(pageNumber);
        }
      }))), !!this.props.pastPosts.length && /*#__PURE__*/React.createElement("div", {
        className: styles.postsWrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.postsWrapTitle
      }, "Past Group Posts"), this.props.pastPosts.map(function (post, index) {
        var imageUrl = post.S3Files.length ? post.S3Files[0].fullyQualifiedUrl : '';
        return /*#__PURE__*/React.createElement(GroupPostItem, {
          post: post,
          image: post.linkUrl && _this3.props.parsedLinks && _this3.props.parsedLinks[post.id] ? _this3.props.parsedLinks[post.id].imageUrl : imageUrl,
          message: post.message ? post.message : _this3.props.parsedLinks && _this3.props.parsedLinks[post.id] ? _this3.props.parsedLinks[post.id].title : '',
          publishAt: post.publishAt,
          key: "postListItem_".concat(index)
        });
      }), this.props.pastCount && this.props.pastCount > postLimit && /*#__PURE__*/React.createElement("div", {
        style: {
          borderTop: '1px solid #8b8b8b',
          paddingTop: 16,
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement(Pagination, {
        activePage: parseInt(this.props.pastPage, 10),
        itemsCountPerPage: postLimit,
        totalItemsCount: this.props.pastCount,
        pageRangeDisplayed: 5,
        onChange: function onChange(pageNumber) {
          _this3.handlePageChange(pageNumber, true);
        }
      }))))), this.props.isLoadingClients && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 50
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), !this.props.isLoadingClients && !clientsWithSocialAccounts.length && /*#__PURE__*/React.createElement(EmptyState, {
        text: "None of your clients have social accounts!",
        iconName: "fa fa-warning",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }), !this.props.isLoadingClients && !this.props.upcomingPosts.length && !!clientsWithSocialAccounts.length && !this.props.pastPosts.length && /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Create One Now",
        buttonOnClick: function buttonOnClick() {
          browserHistory.push('/global/group-posts/compose');
        },
        text: "No group posts.",
        iconName: "fa fa-send",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      })));
    }
  }]);

  return GroupPosts;
}(Component)) || _class);
export { GroupPosts as default };